import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

const backgroundColor = (color: string) => css`
  background-color: ${color};
`;

export const getClasses = (color: string) => ({
  deleteIcon: 'm-0',
  label: 'px-0',
  root: cn(
    'h-26 rounded-4 px-6 py-2 m-2 cursor-pointer max-w-full min-w-0 flex-shrink-0',
    backgroundColor(color),
  ),
});
